import { EventSource } from 'eventsource'

export default class AiStreamingApi {
  private baseUrl: string
  private accessToken: string | undefined | null

  constructor(baseUrl: string, accessToken: string | undefined | null) {
    this.baseUrl = baseUrl
    this.accessToken = accessToken
  }

  setBaseUrl(baseUrl: string) {
    this.baseUrl = baseUrl
  }

  setAccessToken(accessToken: string | undefined | null) {
    this.accessToken = accessToken
  }

  createNoteGenerationStream(weekStart: string): EventSource {
    const url = new URL('/ai/generate-week-note-template/', this.baseUrl)
    url.searchParams.append('week_start', weekStart)
    return this.createAuthenticatedStream(url)
  }

  createSummarizeRecentWorkStream(weekStart: string): EventSource {
    const url = new URL('/ai/summarize-recent-work/', this.baseUrl)
    url.searchParams.append('week_start', weekStart)
    return this.createAuthenticatedStream(url)
  }

  createFindTasksStream(weekStart: string): EventSource {
    const url = new URL('/ai/find-tasks/', this.baseUrl)
    url.searchParams.append('week_start', weekStart)
    return this.createAuthenticatedStream(url)
  }

  private createAuthenticatedStream(url: URL): EventSource {
    const token = this.accessToken
    return new EventSource(url.toString(), {
      fetch: (input, init) =>
        fetch(input, {
          ...init,
          headers: {
            ...init?.headers,
            Authorization: `Bearer ${token}`
          }
        })
    })
  }
}
